import React, { useState } from "react";
import Modal from "react-modal";
import "./PopUp.scss";
import { ReactComponent as Coin } from "./../../../assets/svg/coin.svg";
import { ReactComponent as Close } from "./../../../assets/svg/close.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthValidation } from "../../../hooks/useAuthValidation";

Modal.setAppElement("#root");

function PopUp({ isOpen, closeModal }) {
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  if (loading) {
    return <div className="loading">{t("loading")}</div>;
  }

  if (!user) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel={t("get-award-modal")}
      className="pop-up">
      <button onClick={closeModal} className="row link">
        <Close />
        {t("address-pop-up-close")}
      </button>
      <div>
        <h2>{t("popup-news-title")}</h2>
        <span>{t("popup-news-description")}</span>
      </div>
    </Modal>
  );
}

export default PopUp;
